import React from 'react';
import AppBar from '@mui/material/AppBar';
import Container from '@mui/material/Container';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import aryastackLogo from '../assets/aryastack_icon.png';

export default function Footer() {
    return (
        <AppBar position="static" sx={{ background: 'transparent', boxShadow: 'none', color: 'text.secondary' }}>
            <Container maxWidth="md">
                <Toolbar sx={{ flexDirection: 'column', py: 1.5, gap: 0.5 }}>
                    <Typography style={{ textAlign: 'center' }} variant="body1" color="inherit">
                        © imagetext.xyz
                    </Typography>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: 1,
                            fontSize: '0.75rem',
                            color: 'inherit',
                            mt: 0.5
                        }}
                    >
                        <span>Built with ♥ by</span>
                        <a
                            href="https://aryastack.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            title="AryaStack Technologies — https://aryastack.com"
                            aria-label="AryaStack Technologies"
                            style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '6px',
                                borderRadius: '9999px',
                                backgroundColor: 'rgba(255, 255, 255, 0.95)',
                                padding: '4px 12px',
                                fontSize: '0.75rem',
                                fontWeight: 600,
                                color: '#0B132B',
                                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                                border: '1px solid rgba(0, 0, 0, 0.08)',
                                textDecoration: 'none',
                                transition: 'all 0.2s ease-in-out',
                                cursor: 'pointer'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'scale(1.05)';
                                e.currentTarget.style.backgroundColor = '#ffffff';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'scale(1)';
                                e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.95)';
                            }}
                        >
                            <img
                                src={aryastackLogo}
                                alt="AryaStack Technologies"
                                style={{
                                    height: '16px',
                                    width: 'auto',
                                    objectFit: 'contain',
                                    display: 'block',
                                    pointerEvents: 'none'
                                }}
                            />
                            <span>AryaStack Technologies</span>
                        </a>
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    );
}

